import { useMemo } from 'react';
import { listThreadsWaitingForInput } from '../../components/dashboard/waiting-for-input';
import { useBackgroundExecutionStore } from '../../store/backgroundExecutionStore';

export function useThreadsWaitingForInput(applicationId: string): string[] {
  const executions = useBackgroundExecutionStore(
    (state) => state.pendingExecutionsByToolCallId,
  );

  return useMemo(
    () =>
      listThreadsWaitingForInput({
        executions: executions.values(),
        applicationId,
      }),
    [applicationId, executions],
  );
}
